import { render } from "./DependentsHome.vue?vue&type=template&id=487cb46c&scoped=true&ts=true"
import script from "./DependentsHome.vue?vue&type=script&lang=ts"
export * from "./DependentsHome.vue?vue&type=script&lang=ts"

import "./DependentsHome.vue?vue&type=style&index=0&id=487cb46c&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-487cb46c"]])

export default __exports__